var createElement = require("./vdom/create-element.js")

module.exports = createElement



//////////////////
// WEBPACK FOOTER
// ./~/virtual-dom/create-element.js
// module id = 179
// module chunks = 0